import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Footer = function Footer() {
  return /*#__PURE__*/_jsx("footer", {
    className: "bg-white border-t border-gray-200",
    children: /*#__PURE__*/_jsx("div", {
      className: "max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8",
      children: /*#__PURE__*/_jsxs("div", {
        className: "md:flex md:items-center md:justify-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex justify-center space-x-6 md:order-2",
          children: [/*#__PURE__*/_jsxs("a", {
            href: "#",
            className: "text-gray-400 hover:text-gray-500",
            children: [/*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "Facebook"
            }), /*#__PURE__*/_jsx("svg", {
              className: "h-6 w-6",
              fill: "currentColor",
              viewBox: "0 0 24 24",
              "aria-hidden": "true",
              children: /*#__PURE__*/_jsx("path", {
                fillRule: "evenodd",
                d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
                clipRule: "evenodd"
              })
            })]
          }), /*#__PURE__*/_jsxs("a", {
            href: "#",
            className: "text-gray-400 hover:text-gray-500",
            children: [/*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "X"
            }), /*#__PURE__*/_jsx("svg", {
              className: "h-6 w-6",
              fill: "currentColor",
              viewBox: "0 0 24 24",
              "aria-hidden": "true",
              children: /*#__PURE__*/_jsx("path", {
                d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-8 md:mt-0 md:order-1",
          children: /*#__PURE__*/_jsxs("p", {
            className: "text-center text-base text-gray-400",
            children: ["\xA9 ", new Date().getFullYear(), " Bafkal. All rights reserved."]
          })
        })]
      })
    })
  });
};
export default Footer;